import { createFileRoute, Outlet } from "@tanstack/react-router";
import { BiFiltersProvider } from "@/components/bi/BiFilters";

export const Route = createFileRoute("/bi")({
  component: BiLayout,
});

function BiLayout() {
  return (
    <BiFiltersProvider>
      <Outlet />
    </BiFiltersProvider>
  );
}
